import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiLock } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const policyColumns = [
  {
    title: "Orders",
    links: [["Shipping", "/shipping"], ["Delivery issues", "/delivery-issues"], ["Returns & refunds", "/returns"], ["Cancellations", "/cancellations"], ["International orders", "/international-orders"], ["Pre-orders", "/pre-orders"]],
  },
  {
    title: "Shopping",
    links: [["Payments & pricing", "/payments"], ["Discounts", "/promotions"], ["Sale items", "/sale-items"], ["Product information", "/product-information"], ["Care & safety", "/care-safety"], ["Packaging", "/packaging"]],
  },
  {
    title: "Rights",
    links: [["Privacy", "/privacy"], ["Data rights", "/data-rights"], ["Cookie notice", "/cookies"], ["Accessibility", "/accessibility"], ["Reviews & content", "/reviews-content"], ["Intellectual property", "/intellectual-property"]],
  },
  {
    title: "Store rules",
    links: [["Terms", "/terms"], ["Complaints", "/complaints"], ["Policy updates", "/policy-updates"], ["FAQ", "/faq"], ["All policies", "/policies"], ["Contact", "/contact"]],
  },
];

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-care" aria-labelledby="footer-care-title">
        <div>
          <p className="eyebrow">Customer care</p>
          <h2 id="footer-care-title">Questions<br />welcome.</h2>
        </div>
        <div className="footer-care__contact-wrap">
          <p>Order, product and policy support is handled by email{siteConfig.business.timezone ? ` in the ${siteConfig.business.timezone} time zone` : ""}. Do not send card details.</p>
          <a className="footer-care-link" href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}<FiArrowRight /></a>
        </div>
      </section>

      <div className="footer-main">
        <div className="footer-brand">
          <Link className="footer-wordmark" to="/">
            <span>{siteConfig.logo.symbol}</span>
            <b>{siteConfig.logo.wordmark.slice(0, 3)}</b><em>{siteConfig.logo.wordmark.slice(3)}</em>
          </Link>
          <p>{siteConfig.description}</p>
          <div className="footer-payment"><FiLock /><span><small>Payment platform</small><strong>{siteConfig.commerce.paymentPlatform}</strong></span></div>
          {siteConfig.business.address && <address>{siteConfig.business.address}</address>}
        </div>

        <div className="footer-links">
          {policyColumns.map((column) => (
            <div key={column.title}>
              <h3>{column.title}</h3>
              {column.links.map(([label, to]) => <Link key={to} to={to}>{label}</Link>)}
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {siteConfig.displayName}</span>
        <span>{siteConfig.business.region} · {siteConfig.business.currency} · {siteConfig.business.language}</span>
        <span>{siteConfig.tagline}</span>
      </div>
    </footer>
  );
}

export default Footer;
